import { useSyncExternalStore } from "react";

/** The Solstack app in the Solana dApp Store runs the site in a WebView
 * whose user agent includes this (see components/common/DappStoreBadge.js). */
export const WEB_SHELL_UA = "Solana Mobile Web Shell";

// The user agent never changes, so there's nothing to subscribe to.
const subscribe = () => () => {};
const inWebShell = () => navigator.userAgent.includes(WEB_SHELL_UA);
const onServer = () => false;

/** True inside the dApp Store app. Pages drawn in the browser (the app
 * hosts) know it on their first render, so what the app hides is never
 * painted there. A prerendered page hydrates with false, as it was built,
 * then renders again. */
export function useInWebShell() {
  return useSyncExternalStore(subscribe, inWebShell, onServer);
}
